import React, {useEffect, useState} from 'react';
import './resetPassword.scss';
import * as Yup from "yup";
import {Formik} from "formik";
import PASSWORD_ICON from "assets/icons/password_icon.svg";
import {Button, InputField, Loading} from "components";
import {useLocation, useNavigate} from "react-router-dom";
import {useResetPassword} from "operations/mutations";


export const ResetPasswordFormValidation = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    c_password: Yup.string().required('Password is required').oneOf([Yup.ref('password'), null], 'Passwords must match'),
    code: Yup.string().required('Code is required'),
})

const ERROR_ICON = <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.00195 1.00024L11.0004 10.9987' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
    <path d='M10.9985 1L1.00012 10.9984' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
</svg>;

const ResetPassword = () => {
    const {state} = useLocation();
    const {mutateAsync, isError, isLoading} = useResetPassword();
    const navigate = useNavigate();
    const [isForgetError, setForgetError] = useState(false);
    const [responseMessage, setResponseMessage] = useState<string>(
        'A connectivity issue has occurred. Please check your connection and try again.'
    );


    useEffect(() => {
        setForgetError(isError);
    }, [isError]);


    const onSubmit = async (values: any, {setSubmitting}: any) => {
        // @ts-ignore
        const email = state?.email as string
        await mutateAsync({
            email: email,
            code: values.code,
            password: values.password
        })
            .then((response: { data: { msg: React.SetStateAction<string>; }; }) => {
                setResponseMessage(response.data.msg)
                navigate('/login')
            })
            .catch((err: { response: { data: { message: React.SetStateAction<string>; }; }; }) => {
                setResponseMessage(err.response.data.message)
            })
        setSubmitting(false);

    }
    return (
        <div className={'reset-password'}>
            <h1>Reset Password</h1>
            <p>A password reset email has been sent to your email address. Please enter the code from the email and
                your new password to continue</p>
            {isForgetError &&
            <div
                className='forgot-password_error'>
                <div className='forgot-password_error_circle' onClick={() => setForgetError(false)}>
                    {ERROR_ICON}
                </div>
                <h1>Oops!</h1>
                <p>{responseMessage}</p>
            </div>}
            {isLoading && (
                <div className={'forgot-password_loading'}>
                    <Loading/>
                </div>
            )}
            <Formik
                validateOnMount={false}
                initialValues={{code: "", password: "", c_password: ""}}
                validationSchema={ResetPasswordFormValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <InputField
                                id={'reset_password_code_input'}
                                type="text"
                                classname="signup__input"
                                placeholder={"code"}
                                name="code"
                                onblur={handleBlur}
                                error={errors.code && touched.code}
                                onchange={handleChange}
                                message={errors.code && touched.code && errors.code}
                                inputValue={values.code}
                                image={PASSWORD_ICON}
                            />
                            <InputField
                                id={'reset_password_input'}
                                type="text"
                                classname="signup__input"
                                placeholder={"Password"}
                                name="password"
                                onblur={handleBlur}
                                error={errors.password && touched.password}
                                onchange={handleChange}
                                message={errors.password && touched.password && errors.password}
                                inputValue={values.password}
                                image={PASSWORD_ICON}
                            />

                            <InputField
                                id={'reset_c_password_input'}
                                type="password"
                                classname="signup__input"
                                placeholder={"Confirm Password"}
                                name="c_password"
                                onblur={handleBlur}
                                error={errors.c_password && touched.c_password}
                                onchange={handleChange}
                                message={errors.c_password && touched.c_password && errors.c_password}
                                inputValue={values.c_password}
                                image={PASSWORD_ICON}
                            />
                            <Button type={"primary"} isSubmit={true} text={"Reset Password"}/>

                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default ResetPassword;
